import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22custom-fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22./fonts/FontAwesome6Brands-Regular.woff2%22,%22display%22:%22swap%22,%22variable%22:%22--custom-font-font-awesome-6-pro-brands%22,%22preload%22:false}],%22variableName%22:%22fontAwesome6ProBrands%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'fontAwesome6ProBrands', 'fontAwesome6ProBrands Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
